export const siteSettings = {
  name: "Essential Markets",
  link: "https://essentialmarkets.live",
  email: "support@essentialmarkets.live",
  appLink: "https://app.essentialmarkets.live",
};
